import React from 'react'
import MenuLinks from './MenuLinks'

function Navbar() {
  return (
    <section className='md:block hidden bg-myorangeolor leading-[57px]'>
        <div className='container mx-auto'>
        <div class="flex justify-between items-center w-full">
          <div className='w-[80%]'>
           <MenuLinks set="flex-row" myMargin="mx-7"/>
           </div>
  <div class="flex items-center gap-4 pr-10">
    <a href="https://www.facebook.com/share/1DhBTxYsyF/?mibextid=wwXIfr" target="_blank" className='text-white'>
      <svg class="w-5 h-5 fill-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
        <path d="M44,24c0,10.13-7.52,18.5-17.29,19.81V29h2.49c1.48,0,2.74-1.08,2.97-2.54l0.53-3.42h-5.99v-1.87
          c0-2.18,0.71-4.12,2.75-4.12h1.29c1.1,0,2-0.9,2-2v-2.59c-0.58-0.08-1.8-0.25-4.11-0.25c-4.81,0-7.63,2.54-7.63,8.34v2.49h-1.95
          c-1.66,0-3,1.34-3,3V29h4.95v14.78C11.38,42.33,4,34.03,4,24C4,12.95,12.95,4,24,4S44,12.95,44,24z"/>
      </svg>
    </a>
    <a href="https://www.instagram.com/wholesale.xpress?igsh=MXdrOHdodmpkaGEweg==" target="_blank" className='text-white'>
    <svg class="w-6 h-6 fill-current" viewBox="0 0 24 24">
    <path d="M7.75 2h8.5A5.76 5.76 0 0 1 22 7.75v8.5A5.76 5.76 0 0 1 16.25 22h-8.5A5.76 5.76 0 0 1 2 16.25v-8.5A5.76 5.76 0 0 1 7.75 2zm0 1.5A4.26 4.26 0 0 0 3.5 7.75v8.5A4.26 4.26 0 0 0 7.75 20.5h8.5A4.26 4.26 0 0 0 20.5 16.25v-8.5A4.26 4.26 0 0 0 16.25 3.5h-8.5zM12 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm0 1.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7zm5.25-.88a.88.88 0 1 1-1.75 0 .88.88 0 0 1 1.75 0z"/>
  </svg>
    </a>
  </div>
           </div>
        </div>
    </section>
  )
}

export default Navbar